var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.932,
    height: 139.932,
    viewBox: "0 0 37.024 37.024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter13291",
    width: 1.04,
    height: 1.043,
    x: -0.02,
    y: -0.022,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.154
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.636 -64.638)"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    strokeLinecap: "round",
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.024,
    height: 37.024,
    x: 15.636,
    y: 64.638,
    fill: "none",
    stroke: "none",
    strokeWidth: 0.754,
    opacity: 1,
    ry: 0
  }), /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "none",
    transform: "matrix(1.05192 0 0 1.05192 -3.527 -3.629)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#242424",
    strokeWidth: 0.534,
    d: "M25.849 68.333a.55.55 0 00-.552.551v8.251a.55.55 0 00.552.552H47.15a.55.55 0 00.551-.552v-8.25a.55.55 0 00-.551-.552zM20.979 78.5a.55.55 0 00-.552.551v8.252a.55.55 0 00.551.551H42.28a.55.55 0 00.552-.551v-8.252a.55.55 0 00-.552-.55zm9.655 10.083a.55.55 0 00-.552.552v8.25c0 .306.246.552.552.552h21.302a.551.551 0 00.551-.552v-8.25a.55.55 0 00-.551-.552z",
    filter: "url(#filter13291)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.56,
    transform: "matrix(.95422 0 0 .95422 3.107 2.74)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.48,
    height: 9.803,
    x: 21.522,
    y: 67.011,
    fill: "#f8f9fa",
    stroke: "#242424",
    opacity: 1,
    ry: 0.578
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.572,
    height: 5.572,
    x: 23.891,
    y: 69.126,
    fill: "#aec6dd",
    stroke: "#242424",
    opacity: 1,
    ry: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#242424",
    d: "M31.738 69.49h5.43",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#242424",
    d: "M31.772 71.219h11.271",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#242424",
    d: "M31.772 72.575h11.271",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#242424",
    d: "M31.745 73.905h9.45",
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.48,
    height: 9.803,
    x: 16.418,
    y: 77.667,
    fill: "#3b69a5",
    stroke: "#242424",
    opacity: 1,
    ry: 0.578
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.572,
    height: 5.572,
    x: 18.787,
    y: 79.782,
    fill: "#f8f9fa",
    stroke: "#242424",
    opacity: 1,
    ry: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#f8f9fa",
    d: "M26.634 80.147h5.43",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#f8f9fa",
    d: "M26.668 81.875h11.27",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#f8f9fa",
    d: "M26.668 83.232h11.27",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#f8f9fa",
    d: "M26.64 84.561h9.45",
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.48,
    height: 9.803,
    x: 26.537,
    y: 88.234,
    fill: "#f8f9fa",
    stroke: "#242424",
    opacity: 1,
    ry: 0.578
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.572,
    height: 5.572,
    x: 28.906,
    y: 90.349,
    fill: "#3b69a5",
    stroke: "#242424",
    opacity: 1,
    ry: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#242424",
    d: "M36.753 90.713h5.43",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#242424",
    d: "M36.787 92.442h11.27",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#242424",
    d: "M36.787 93.798h11.27",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81b0ff",
    stroke: "#242424",
    d: "M36.76 95.128h9.45",
    opacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDraft);
export default __webpack_public_path__ + "static/media/profile_draft.450bb7f6541c67406194abfb15c85b1d.svg";
export { ForwardRef as ReactComponent };